import React from 'react';

import { Typography } from '@mui/material';

import { overridePlaceholderStyles } from '../Alerts.styles';

// The Override column's empty state: a muted em-dash so a row with no override
// reads as intentionally blank rather than broken. Shared by leaf and category rows.
const OverridePlaceholder = () => (
  <Typography sx={overridePlaceholderStyles} variant="regular14">
    —
  </Typography>
);

export default OverridePlaceholder;
